{
  "actions": {
    "apply": "Застосувати",
    "cancel": "Скасувати",
    "clear": "Очистити",
    "close": "Закрити",
    "confirm": "Підтвердити",
    "delete": "Видалити",
    "done": "Готово",
    "edit": "Редагувати",
    "more": "Ще",
    "remove": "Прибрати",
    "retry": "Повторити",
    "save": "Зберегти"
  },
  "states": {
    "loading": "Завантаження…",
    "saving": "Збереження…"
  },
  "time": {
    "justNow": "щойно"
  },
  "validation": {
    "required": "Обов'язкове поле"
  },
  "errors": {
    "aborted": "Запит скасовано",
    "badRequest": "Не вдалося виконати запит. Перевірте дані та спробуйте ще раз.",
    "conflict": "Дані змінилися, поки ви їх редагували. Оновіть сторінку та спробуйте ще раз.",
    "forbidden": "У вас немає доступу до цього розділу.",
    "forbiddenTitle": "Немає доступу",
    "gone": "Це більше недоступно.",
    "network": "Немає з'єднання із сервером. Перевірте підключення до інтернету.",
    "notFound": "Об'єкт не знайдено або його видалено.",
    "rateLimited": "Забагато запитів. Зачекайте трохи та повторіть.",
    "renderFailed": "Не вдалося відобразити вміст",
    "renderFailedHint": "Закрийте панель і спробуйте відкрити її знову.",
    "server": "На сервері сталася помилка. Спробуйте ще раз трохи згодом.",
    "tooLarge": "Файл завеликий.",
    "unauthorized": "Сесія закінчилася. Увійдіть знову.",
    "unknown": "Щось пішло не так",
    "validation": "Перевірте правильність заповнення полів.",
    "adminNetwork": "Ви адміністратор, але не з цієї мережі: роль адміністратора доступна лише з дозволених мереж (Адміністрування → Безпека входу). Підключіться з офісу або через VPN."
  },
  "fileErrors": {
    "invalid_multipart": "Завантаження перервалося або файл пошкоджено. Спробуйте ще раз.",
    "invalid_thumbnail_size": "Такий розмір прев’ю недоступний.",
    "multipart_required": "Не вдалося надіслати файл. Спробуйте ще раз.",
    "no_file": "Виберіть файл для завантаження.",
    "not_found": "Файл не знайдено або видалено.",
    "scan_pending": "Файл ще перевіряється на віруси. Спробуйте за хвилину.",
    "signature_expired": "Термін дії посилання на файл минув. Оновіть сторінку.",
    "signature_invalid": "Посилання на файл недійсне.",
    "signature_missing": "Посилання на файл неповне.",
    "thumbnail_not_ready": "Прев’ю ще не готове.",
    "too_large": "Файл завеликий.",
    "quota_exceeded": "Ви завантажили забагато за добу. Спробуйте пізніше.",
    "upload_pending_limit": "Забагато незавершених завантажень. Завершіть або скасуйте частину з них.",
    "upload_expired": "Завантаження застаріло. Почніть його заново.",
    "upload_not_found": "Завантаження не знайдено. Почніть його заново.",
    "upload_chunk_invalid": "Частину файлу пошкоджено. Завантажте файл заново.",
    "upload_size_invalid": "Порожній файл не можна завантажити частинами."
  },
  "session": {
    "unreachableTitle": "Сервер недоступний",
    "unreachableHint": "Не вдалося підключитися до Orbita. Перевірте з'єднання та повторіть спробу."
  },
  "avatarStack": {
    "label_one": "{{count}} учасник",
    "label_few": "{{count}} учасники",
    "label_many": "{{count}} учасників",
    "label_other": "{{count}} учасника",
    "andMore_one": "і ще {{count}}",
    "andMore_few": "і ще {{count}}",
    "andMore_many": "і ще {{count}}",
    "andMore_other": "і ще {{count}}"
  },
  "pickers": {
    "choosePerson": "Оберіть співробітника",
    "choosePeople": "Оберіть співробітників",
    "chooseGroup": "Оберіть групу",
    "chooseGroups": "Оберіть групи",
    "chooseDepartment": "Оберіть підрозділ",
    "chooseDepartments": "Оберіть підрозділи",
    "searchPeople": "Пошук співробітників…",
    "searchGroups": "Пошук груп і проєктів…",
    "searchDepartments": "Пошук підрозділів…",
    "noPeople": "Нікого не знайдено",
    "noGroups": "Групи не знайдено",
    "noDepartments": "Підрозділи не знайдено",
    "people": "Співробітники",
    "group": "Група",
    "project": "Проєкт",
    "members_one": "{{count}} учасник",
    "members_few": "{{count}} учасники",
    "members_many": "{{count}} учасників",
    "members_other": "{{count}} учасника",
    "loadError": "Не вдалося завантажити список"
  },
  "audience": {
    "everyone": "Усі співробітники",
    "add": "Додати",
    "choose": "Обрати отримувачів",
    "tabs": {
      "users": "Співробітники",
      "departments": "Відділи",
      "groups": "Групи"
    }
  },
  "date": {
    "pickDate": "Оберіть дату",
    "pickDateTime": "Оберіть дату й час",
    "pickRange": "Оберіть період",
    "time": "Час",
    "today": "Сьогодні",
    "presets": {
      "today": "Сьогодні",
      "yesterday": "Учора",
      "thisWeek": "Цей тиждень",
      "last7Days": "Останні 7 днів",
      "thisMonth": "Цей місяць",
      "last30Days": "Останні 30 днів",
      "thisYear": "Цей рік"
    }
  },
  "table": {
    "columns": "Колонки",
    "toggleColumns": "Показувати колонки",
    "empty": "Немає даних",
    "sortBy": "Сортувати за полем «{{column}}»",
    "range": "{{from}}–{{to}} з {{total}}",
    "selected_one": "Вибрано {{count}} рядок",
    "selected_few": "Вибрано {{count}} рядки",
    "selected_many": "Вибрано {{count}} рядків",
    "selected_other": "Вибрано {{count}} рядка",
    "rowsPerPage": "Рядків на сторінці",
    "page": "Сторінка {{page}} з {{pages}}",
    "firstPage": "Перша сторінка",
    "previousPage": "Попередня сторінка",
    "nextPage": "Наступна сторінка",
    "lastPage": "Остання сторінка",
    "selectAll": "Вибрати всі рядки",
    "selectRow": "Вибрати рядок"
  },
  "files": {
    "attach": "Прикріпити",
    "browse": "Оберіть файли",
    "orDrop": "або перетягніть їх сюди",
    "dropzoneLabel": "Завантажити файли",
    "maxSize": "До {{max}} на файл",
    "tooLarge": "«{{name}}» більший за {{max}}",
    "notAccepted": "Файл «{{name}}» тут не підтримується",
    "tooMany_one": "Можна прикріпити не більше {{count}} файлу",
    "tooMany_few": "Можна прикріпити не більше {{count}} файлів",
    "tooMany_many": "Можна прикріпити не більше {{count}} файлів",
    "tooMany_other": "Можна прикріпити не більше {{count}} файлу",
    "failed": "Помилка",
    "cancelUpload": "Скасувати завантаження",
    "scanPending": "Перевіряється на віруси…",
    "scanClean": "Перевірено",
    "scanInfected": "Знайдено вірус, файл видалено",
    "retrying": "З’єднання перервалося, повтор {{attempt}}…",
    "offline": "Немає мережі — завантаження продовжиться саме",
    "resumed": "Продовжуємо: {{size}} уже на сервері",
    "download": "Завантажити",
    "openInNewTab": "Відкрити в новій вкладці",
    "preview": "Перегляд «{{name}}»",
    "previewFailed": "Не вдалося завантажити попередній перегляд.",
    "noPreview": "Для цього типу файлів немає попереднього перегляду.",
    "previous": "Попередній файл",
    "next": "Наступний файл",
    "remove": "Прибрати «{{name}}»"
  },
  "richText": {
    "placeholder": "Напишіть що-небудь…",
    "toolbar": "Форматування",
    "undo": "Скасувати",
    "redo": "Повторити",
    "textStyle": "Стиль тексту",
    "paragraph": "Звичайний текст",
    "heading": "Заголовок {{level}}",
    "bold": "Жирний",
    "italic": "Курсив",
    "underline": "Підкреслений",
    "strike": "Закреслений",
    "code": "Код",
    "link": "Посилання",
    "linkUrl": "Адреса посилання",
    "invalidUrl": "Введіть коректну адресу, наприклад https://example.com",
    "removeLink": "Видалити посилання",
    "bulletList": "Маркований список",
    "orderedList": "Нумерований список",
    "taskList": "Чек-лист",
    "quote": "Цитата",
    "codeBlock": "Блок коду",
    "divider": "Роздільник",
    "callout": "Виноска",
    "callouts": {
      "info": "Примітка",
      "tip": "Порада",
      "warning": "Увага",
      "danger": "Важливо"
    },
    "removeCallout": "Прибрати виноску",
    "mention": "Згадати співробітника",
    "mentionPeople": "Згадка співробітника",
    "image": "Зображення",
    "uploadingImage": "Завантажуємо «{{name}}»…",
    "imageUploaded": "Зображення додано",
    "table": "Таблиця",
    "insertTable": "Вставити таблицю",
    "addRow": "Додати рядок",
    "addColumn": "Додати колонку",
    "toggleHeader": "Рядок заголовків",
    "deleteRow": "Видалити рядок",
    "deleteColumn": "Видалити колонку",
    "deleteTable": "Видалити таблицю",
    "dropImagesOnly": "У текст можна вставити лише зображення. Інші файли прикріпіть."
  },
  "comments": {
    "title": "Коментарі",
    "placeholder": "Напишіть коментар…",
    "send": "Надіслати",
    "showEarlier": "Показати попередні коментарі",
    "empty": "Коментарів поки немає",
    "emptyHint": "Почніть обговорення першим.",
    "loadError": "Не вдалося завантажити коментарі",
    "edited": "змінено",
    "you": "ви",
    "deleteTitle": "Видалити коментар?",
    "deleteDescription": "Коментар буде видалено без можливості відновлення."
  },
  "reactions": {
    "add": "Додати реакцію",
    "whoReacted": "Хто відреагував",
    "toggle_one": "{{reaction}}: {{count}} реакція",
    "toggle_few": "{{reaction}}: {{count}} реакції",
    "toggle_many": "{{reaction}}: {{count}} реакцій",
    "toggle_other": "{{reaction}}: {{count}} реакції",
    "like": "Подобається",
    "love": "Супер",
    "laugh": "Смішно",
    "wow": "Дивовижно",
    "sad": "Сумно",
    "angry": "Обурливо"
  },
  "kanban": {
    "empty": "Перетягніть картку сюди",
    "instructions": "Щоб узяти картку, натисніть пробіл. Переміщуйте стрілками, пробіл або Enter — відпустити, Escape — скасувати. Enter відкриває картку.",
    "pickedUp": "Картку {{id}} взято",
    "over": "Над колонкою «{{column}}»",
    "dropped": "Картку переміщено в колонку «{{column}}»",
    "cancelled": "Переміщення скасовано",
    "scrollLeft": "Прокрутити ліворуч",
    "scrollRight": "Прокрутити праворуч"
  },
  "sidePanel": {
    "title": "Панель",
    "copyLink": "Скопіювати посилання",
    "linkCopied": "Посилання скопійовано",
    "unavailable": "Панель недоступна",
    "unknownType": "Модуль, який відкриває панелі «{{type}}», не встановлено."
  },
  "inlineEdit": {
    "empty": "Не вказано"
  },
  "placeholder": {
    "badge": "Незабаром",
    "title": "Розділ у розробці",
    "description": "Команда вже працює над цим модулем. Навігація та інтерфейс порталу готові — можливості нижче з'являться в найближчих версіях."
  },
  "messengerTabs": {
    "label": "Розділи месенджера"
  },
  "security": {
    "showPassword": "Показати пароль",
    "hidePassword": "Сховати пароль",
    "actions": {
      "cancel": "Скасувати",
      "done": "Готово"
    },
    "setup": {
      "title": "Увімкнути двофакторну автентифікацію",
      "description": "Після пароля під час входу потрібен буде код із застосунку на телефоні.",
      "steps": "Кроки",
      "step": {
        "password": "Пароль",
        "scan": "Застосунок",
        "codes": "Резервні коди"
      },
      "passwordHint": "Введіть пароль, щоб продовжити.",
      "password": "Ваш пароль",
      "scanHint": "Відскануйте QR-код у застосунку-автентифікаторі (Google Authenticator, Microsoft Authenticator, 2FAS, Aegis…) і введіть 6-значний код, який він покаже.",
      "qrAlt": "QR-код для застосунку-автентифікатора",
      "manualKey": "Не виходить відсканувати? Введіть ключ",
      "copyKey": "Скопіювати ключ",
      "manualHint": "Код за часом (TOTP), 6 цифр, 30 секунд.",
      "code": "6-значний код",
      "enabled": "Двофакторну автентифікацію увімкнено.",
      "saved": "Я зберіг(ла) резервні коди в надійному місці",
      "next": "Продовжити",
      "confirm": "Увімкнути",
      "done": "Завершити"
    },
    "recovery": {
      "title": "Резервні коди",
      "warning": "Збережіть ці коди зараз: вони показуються лише раз. Кожен дозволить увійти один раз, якщо ви втратите телефон.",
      "fileHeading": "Резервні коди Orbita (кожен діє один раз)",
      "copy": "Копіювати",
      "copied": "Скопійовано",
      "download": "Завантажити",
      "print": "Друк"
    },
    "twoFactor": {
      "title": "Двофакторна автентифікація",
      "description": "Код із застосунку на телефоні на додачу до пароля захищає обліковий запис, навіть якщо пароль витік.",
      "on": "Увімкнено",
      "off": "Вимкнено",
      "graceUntil": "Адміністратор вимагає двофакторну автентифікацію. Увімкніть її до {{date}}, інакше під час входу її вимагатимуть насамперед.",
      "since": "Увімкнено з {{date}}",
      "codesLeft_one": "Залишився {{count}} резервний код.",
      "codesLeft_few": "Залишилося {{count}} резервні коди.",
      "codesLeft_many": "Залишилося {{count}} резервних кодів.",
      "codesLeft_other": "Залишилося {{count}} резервних кодів.",
      "fewCodes": "Резервних кодів майже не лишилося. Створіть нові, поки вони не закінчилися.",
      "requiredNote": "Адміністратор вимагає двофакторну автентифікацію, тому вимкнути її не можна.",
      "newCodes": "Нові резервні коди",
      "turnOff": "Вимкнути",
      "turnOn": "Увімкнути",
      "disabled": "Двофакторну автентифікацію вимкнено."
    },
    "disable": {
      "title": "Вимкнути двофакторну автентифікацію",
      "description": "Підтвердьте паролем і кодом із застосунку (або резервним кодом).",
      "submit": "Вимкнути"
    },
    "regenerate": {
      "title": "Нові резервні коди",
      "description": "Старі коди перестануть діяти. Підтвердьте паролем і кодом із застосунку.",
      "submit": "Створити коди",
      "done": "Збережіть нові коди. Старі більше не діють."
    },
    "reauth": {
      "password": "Пароль",
      "code": "Код",
      "codePlaceholder": "123 456",
      "codeHint": "6-значний код із застосунку або резервний код."
    },
    "sessions": {
      "title": "Пристрої та сеанси",
      "description": "Де ви ввійшли до порталу. Завершіть те, чого не впізнаєте.",
      "empty": "Немає активних сеансів.",
      "loadError": "Не вдалося завантажити сеанси.",
      "current": "Цей пристрій",
      "lastActive": "активність {{when}}",
      "signedIn": "вхід {{when}}",
      "signOut": "Завершити",
      "signOutOthers": "Вийти на всіх інших",
      "confirmTitle": "Завершити сеанс «{{device}}»?",
      "confirmText": "На цьому пристрої доведеться ввійти знову. Відкриті там сторінки одразу перестануть отримувати оновлення.",
      "confirmAllTitle": "Вийти на всіх інших пристроях?",
      "confirmAllText": "На всіх інших пристроях доведеться ввійти знову. Цей пристрій залишиться в системі.",
      "signedOut": "Сеанс завершено.",
      "signedOutMany_one": "Завершено {{count}} сеанс.",
      "signedOutMany_few": "Завершено {{count}} сеанси.",
      "signedOutMany_many": "Завершено {{count}} сеансів.",
      "signedOutMany_other": "Завершено {{count}} сеансів."
    },
    "rules": {
      "title": "Вимоги до пароля",
      "length": "Мінімальна довжина: {{n}}",
      "distinct": "Різних символів — не менше {{n}}",
      "mixedCase": "Мала й велика літери",
      "digit": "Цифра",
      "symbol": "Символ (не літера й не цифра)",
      "common": "Не зі списку найпоширеніших паролів",
      "history": "Відрізняється від попередніх паролів (пам'ятаємо останні {{n}})"
    },
    "reasons": {
      "too_short": "Пароль надто короткий: мінімальна довжина — {{n}}.",
      "few_distinct": "Використайте щонайменше 4 різні символи.",
      "needs_mixed_case": "Потрібні мала й велика літери.",
      "needs_digit": "Додайте цифру.",
      "needs_symbol": "Додайте символ.",
      "common": "Це один із найпоширеніших паролів.",
      "reused": "Ви нещодавно вже використовували цей пароль (пам'ятаємо останні {{n}}).",
      "other": "Пароль не відповідає вимогам."
    },
    "restricted": {
      "signOut": "Вийти",
      "twoFactorTitle": "Налаштуйте двофакторну автентифікацію",
      "twoFactorText": "Адміністратор вимагає двофакторну автентифікацію для вашого облікового запису. Налаштуйте її, щоб продовжити: потрібна хвилина й застосунок-автентифікатор на телефоні.",
      "passwordTitle": "Термін дії пароля минув",
      "passwordText": "Адміністратор обмежив термін використання пароля. Оберіть новий, щоб продовжити."
    },
    "password": {
      "current": "Поточний пароль",
      "new": "Новий пароль",
      "confirm": "Повторіть новий пароль",
      "mismatch": "Паролі не збігаються",
      "submit": "Змінити пароль"
    }
  },
  "truncation": {
    "showing": "Показано {{shown}} із {{total}}"
  },
  "roles": {
    "builtIn": {
      "admin": {
        "title": "Адміністратор",
        "description": "Усі права, завжди. Не редагується."
      },
      "user": {
        "title": "Співробітник",
        "description": "Кожен співробітник; не дає адміністративних прав."
      },
      "hr": {
        "title": "HR",
        "description": "Вимикає співробітників і передає їхні справи; права можна розширити."
      },
      "integrator": {
        "title": "Інтегратор",
        "description": "Підключає портал до інших систем: вебхуки, налаштування процесів, пошуковий індекс, сторінки стану."
      },
      "auditor": {
        "title": "Аудитор",
        "description": "Читає журнал і сторінки стану; нічого не змінює."
      }
    }
  },
  "menuEditor": {
    "sections": {
      "primary": "Швидкий доступ",
      "main": "Меню",
      "admin": "Адміністрування"
    },
    "drag": "Перетягнути: {{label}}",
    "moveUp": "Вище: {{label}}",
    "moveDown": "Нижче: {{label}}",
    "hide": "Сховати: {{label}}",
    "show": "Показати: {{label}}",
    "hiddenBadge": "Схований"
  },
  "history": {
    "off": "Історію змін вимкнено адміністратором",
    "empty": "Змін поки немає",
    "emptyHint": "Тут видно правки полів: хто, коли і що змінив.",
    "more": "Показати ще",
    "empty_value": "порожньо",
    "yes": "так",
    "no": "ні",
    "showMore": "ще",
    "less": "згорнути",
    "actor": {
      "unknown": "Невідомий автор",
      "process": "Бізнес-процес",
      "robot": "Робот",
      "trigger": "Тригер",
      "system": "Система"
    },
    "kind": {
      "process": "процес",
      "robot": "робот",
      "trigger": "тригер",
      "system": "система",
      "api-token": "API-токен"
    },
    "fields": {
      "title": "Назва",
      "status": "Статус / стадія",
      "category": "Воронка",
      "responsible": "Відповідальний",
      "observers": "Спостерігачі",
      "description": "Опис",
      "firstName": "Ім’я",
      "lastName": "Прізвище",
      "secondName": "По батькові",
      "companyTitle": "Назва компанії",
      "position": "Посада",
      "phones": "Телефони",
      "emails": "E-mail",
      "websites": "Сайти",
      "address": "Адреса",
      "source": "Джерело",
      "sourceDescription": "Опис джерела",
      "amount": "Сума",
      "probability": "Ймовірність",
      "expectedCloseDate": "Очікувана дата закриття",
      "companyId": "Компанія",
      "contactId": "Контакт",
      "dealId": "Угода",
      "leadId": "Лід",
      "quoteId": "Пропозиція",
      "contacts": "Контакти",
      "companies": "Компанії",
      "lossReason": "Причина провалу",
      "lossComment": "Коментар до провалу",
      "closedAt": "Закрито",
      "birthday": "День народження",
      "type": "Тип",
      "industry": "Галузь",
      "employees": "Працівники",
      "revenue": "Річний оборот",
      "number": "Номер",
      "issueDate": "Дата виставлення",
      "validUntil": "Діє до",
      "dueDate": "Сплатити до",
      "paidAt": "Сплачено",
      "terms": "Умови",
      "beginDate": "Початок",
      "closeDate": "Завершення"
    },
    "keepForField": "Вести історію змін"
  }
}
